import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
export function CtaSection() {
  return <section id="compra" className="py-24 px-4 bg-cream relative overflow-hidden" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-cream-alt rounded-3xl p-10 md:p-16 shadow-2xl border border-gold-start/30" data-id="element-83">
          <h2 className="text-4xl md:text-5xl font-bold text-brown mb-6" data-id="element-84">
            Empieza hoy tu camino hacia una mente más tranquila
          </h2>
          <p className="text-xl md:text-2xl text-brown-light mb-8 max-w-2xl mx-auto" data-id="element-85">
            Accede ahora al Mega Pack Claridad Mental y descubre una forma
            diferente de relacionarte con tu mente.
          </p>

          <PriceBlock data-id="element-86" />

          <CtaButton text="QUIERO ACCEDER AL MEGA PACK" className="w-full md:w-auto md:px-12 md:py-6 text-xl md:text-2xl" data-id="element-87" />
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full max-h-[500px] bg-gold-start/5 blur-3xl rounded-full pointer-events-none" data-id="element-88"></div>
    </section>;
}